import { pushEvent } from './datalayer';
import { identify } from './customer-io';

(($) => {
  $(() => {
    const $newsletterModal = $('#newsletter-modal');

    if ($newsletterModal.length) {
      const $form = $newsletterModal.find('form');
      const $firstName = $form.find('input[name="first_name"]');
      const $lastName = $form.find('input[name="last_name"]');
      const $email = $form.find('input[name="email"]');
      const $optIn = $form.find('input[name="opt_in"]');
      const $submit = $form.find('button[type="submit"]');

      const updateUI = (state = 'default' ) => {
        let antiState = 'submitted'

        if ( 'default' !== state ) {
          antiState = 'default'
        }

        $newsletterModal.find(`[data-state="${antiState}"]`).addClass('d-none');
        $newsletterModal.find(`[data-state="${state}"]`).removeClass('d-none');
      }

      $optIn.on('change', () => {
        $submit.prop('disabled', !$optIn.prop('checked'));
      });

      $form.on('submit', (e) => {
        e.preventDefault();

        const optInEvent = {
          event: 'email subscription',
          attributes: {
            eventDetail: 'email opt in',
            eventLocation: 'footer',
          },
        };

        pushEvent(optInEvent);

        const identity = {
          id: $email.val(),
          first_name: $firstName.val(),
          last_name: $lastName.val(),
          email: $email.val(),
          optin_src: $optIn.val(),
        };

        identify(identity);

        updateUI( 'submitted' );
      });

      $newsletterModal.on('hidden.bs.modal', () => {
        updateUI('default');
      });
    }
  });
})(jQuery);
